import { Model } from "@vuex-orm/core"

export default class User extends Model {
  static entity = "users"

  static fields() {
    return {
      id: this.string(""),
      name: this.string(""),
      dan: this.number(0),
      danclass: this.string(""),
      designation: this.attr([]),
      state: this.string(""),
      nation: this.string(""),
      country: this.string(""),
      address: this.attr([]),
      phone: this.attr([]),
      mobile: this.attr([]),
      fax: this.attr([]),
      email: this.attr([]),
      website: this.attr([]),
      facebook: this.string(""),
      image: this.string(""),
      repimage: this.string(""),
      adminposition: this.number(0),
      sciposition: this.number(0),
      itaposition: this.number(0),
      danposition: this.number(0),
      wdanposition: this.number(0),
      repposition: this.number(0)
    }
  }

  id!: string
  name!: string
  dan!: number
  danclass!: string
  designation!: string[]
  state!: string
  nation!: string
  country!: string
  address!: string[]
  phone!: string[]
  mobile!: string[]
  fax!: string[]
  email!: string[]
  website!: string[]
  facebook!: string
  image!: string
  repimage!: string
  adminposition!: number
  sciposition!: number
  itaposition!: number
  danposition!: number
  wdanposition!: number
  repposition!: number
}
